const formatPhoneNumber = (
    phone?: { prefix?: string | null | undefined; number?: string | null | undefined } | null | undefined
): string => {
    if (!phone?.number) return ''
    const formattedNumber = phone.number.replace(/(\d{3})(?=\d)/g, '$1 ').trim()
    const cleanPrefix = phone.prefix?.replace(/^\+/, '')
    return cleanPrefix ? `+${cleanPrefix} ${formattedNumber}` : formattedNumber
}

export default formatPhoneNumber
